import React, { useState } from 'react';
import { motion } from 'framer-motion';

const Catalogos = () => {
  const [selectedCategory, setSelectedCategory] = useState('sillas');

  const categorias = [
    { id: 'sillas', name: 'Sillas & Sillones' },
    { id: 'muebles', name: 'Muebles' },
    { id: 'paneles', name: 'Paneles Acústicos' }
  ];

  const catalogosSillas = [
    {
      id: 'requiez',
      nombre: 'Reqüiez',
      pdf: '/catalogos/REQUIEZ.pdf',
      descripcion: 'Marca mexicana con casi 40 años de experiencia, especializada en sillas ergonómicas reconocidas por su diseño, tecnología y compromiso ambiental. Ideal para oficinas, salas de juntas y espacios colaborativos.',
      color: '#8B2635',
      imagen: '/catalogos/previews/requiez.jpg'
    },
    {
      id: 'labenze',
      nombre: 'Labenze',
      pdf: '/catalogos/LABENZE.pdf',
      descripcion: 'Marca especializada en mobiliario contract de alta gama. Sus productos combinan diseño italiano, funcionalidad, sostenibilidad y bienestar, ofreciendo soluciones elegantes y versátiles para proyectos exigentes de hotelería, arquitectura y espacios comerciales.',
      color: '#A83D4F',
      imagen: '/catalogos/previews/labenze.jpg'
    },
    {
      id: 'infiniti',
      nombre: 'Infiniti',
      pdf: '/catalogos/INFINITI.pdf',
      descripcion: 'Marca italiana especializada en mobiliario contemporáneo para espacios corporativos, educativos, hoteleros y restauranteros. Sus productos destacan por su diseño funcional, materiales sostenibles y fabricación 100% Made in Italy.',
      color: '#6B1D2A',
      imagen: '/catalogos/previews/infiniti.jpg'
    },
    {
      id: 'okamura',
      nombre: 'Okamura',
      pdf: '/catalogos/Verissa__Okamura_25.pdf',
      descripcion: 'Marca japonesa con más de 75 años de historia, reconocida por su precisión, innovación y compromiso con la calidad. Su mobiliario de oficina combina funcionalidad, diseño y tecnología para crear entornos de trabajo más productivos, cómodos y estéticamente impecables.',
      color: '#8B2635',
      imagen: '/catalogos/previews/okamura.jpg'
    },
    {
      id: 'bratti',
      nombre: 'Bratti',
      pdf: '/catalogos/Verissa_Bratti_2025.pdf',
      descripcion: 'Marca especializada en mobiliario contract para sectores de alto tráfico como hoteles, hotelería y restaurantes. Sus productos combinan diseño y funcionalidad con altos estándares de calidad, ofreciendo soluciones duraderas para proyectos que requieren resistencia, estilo y carácter.',
      color: '#6B1D2A',
      imagen: '/catalogos/previews/bratti.jpg'
    }
  ];

  const catalogosMuebles = [
    {
      id: 'verissa-mobiliario',
      nombre: 'Verissa',
      pdf: '/catalogos/Verissa_Mobiliario.pdf',
      descripcion: 'Catálogo de mobiliario Verissa con soluciones para espacios corporativos, comerciales y profesionales. Una selección integral pensada para proyectos que buscan diseño, funcionalidad y calidad.',
      color: '#8B2635',
      imagen: '/catalogos/previews/verissa.jpg'
    },
    {
      id: 'techno-muebles',
      nombre: 'Techno',
      pdf: '/catalogos/TECHNO.pdf',
      descripcion: 'Empresa mexicana con más de 35 años de experiencia en mobiliario de oficina. Su catálogo destaca por la personalización, el diseño innovador y una sólida infraestructura que garantiza entregas rápidas y productos certificados.',
      color: '#8B2635',
      imagen: '/catalogos/previews/techno.jpg'
    },
    {
      id: 'quadrifoglio',
      nombre: 'Quadrifoglio',
      pdf: '#',
      descripcion: 'Marca italiana con más de 30 años de experiencia en el diseño y fabricación de mobiliario profesional. Su catálogo ofrece soluciones completas para oficinas y proyectos contract, con un enfoque en ergonomía, bienestar, sostenibilidad y diseño contemporáneo.',
      color: '#A83D4F',
      imagen: '/catalogos/previews/quadrifoglio.jpg'
    },
    {
      id: 'linea-italia',
      nombre: 'Linea Italia',
      pdf: '/catalogos/Verissa_LineaItalia_25.pdf',
      descripcion: 'Fabricante mexicano con más de 30 años de experiencia en mobiliario de oficina. Con presencia en México, Estados Unidos y Canadá, su enfoque en innovación, ergonomía y producción de alta precisión garantiza soluciones funcionales, duraderas y con diseño corporativo de alto nivel.',
      color: '#6B1D2A',
      imagen: '/assets/Logos/italia.png'
    }
  ];

  const catalogosPaneles = [
    {
      id: 'sonara',
      nombre: 'Sonara',
      pdf: '/catalogos/Sonara.pdf',
      descripcion: 'Marca de paneles acústicos de alto rendimiento fabricados 100% con fibras de poliéster y sin químicos aglutinantes. Ideales para proyectos de interiorismo y arquitectura, sus soluciones ofrecen confort acústico con diseño funcional y contemporáneo.',
      color: '#8B2635',
      imagen: '/catalogos/previews/sonara.jpg'
    }
  ];

  const getCatalogos = () => {
    switch (selectedCategory) {
      case 'sillas':
        return catalogosSillas;
      case 'muebles':
        return catalogosMuebles;
      case 'paneles':
        return catalogosPaneles;
      default:
        return catalogosSillas;
    }
  };

  const handleViewPdf = (pdf) => {
    if (pdf === '#') return;
    window.open(pdf, '_blank', 'noopener,noreferrer');
  };

  const handleDownloadPdf = (pdf) => {
    if (pdf === '#') return;

    // Descarga forzada creando un link temporal.
    const link = document.createElement('a');
    link.href = pdf;
    // El nombre final depende del archivo servido; usamos una base humana.
    link.download = pdf.split('/').pop() || 'catalogo.pdf';
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <section className="catalogos-page" id="catalogos">
      <div className="catalogos-hero">
        <div className="catalogos-hero-content">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Conoce nuestros catálogos y transforma tus espacios
          </motion.h1>
          <motion.div
            className="catalogos-intro"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p>En Verissa Diseño Interior, creemos que cada espacio tiene el potencial de inspirar. Nos especializamos en ofrecer soluciones integrales de diseño que combinan estética, funcionalidad y calidad. Nuestro compromiso es ayudarte a transformar tus entornos en lugares que reflejen tu visión, necesidades y objetivos.</p>
            <p>Trabajamos de la mano con proveedores líderes en la industria para ofrecerte una selección especializada de mobiliario, telas, acabados y elementos que elevan la experiencia en espacios corporativos, comerciales, hoteleros, educativos, de salud y otros entornos públicos o profesionales.</p>
            <p>Explora nuestros catálogos y descubre todo lo que Verissa puede aportar a tu próximo proyecto de diseño.</p>
          </motion.div>
        </div>
        <motion.div
          className="catalogos-hero-graphic"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <div className="catalogos-hero-image-wrapper">
            <img
              src="/assets/Images/bratti_Hub.jpg"
              alt="Ambiente de mobiliario Bratti Hub"
              className="catalogos-hero-image"
            />
          </div>
        </motion.div>
      </div>

      <div className="catalogos-container">
        <div className="catalogos-filters">
          {categorias.map((categoria) => (
            <motion.button
              key={categoria.id}
              className={`filter-btn ${selectedCategory === categoria.id ? 'active' : ''}`}
              onClick={() => setSelectedCategory(categoria.id)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {categoria.name}
            </motion.button>
          ))}
        </div>

        <motion.div
          className="catalogos-grid"
          key={selectedCategory}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {getCatalogos().map((catalogo, index) => (
            <motion.div
              key={catalogo.id}
              className="catalogo-card"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -10, transition: { duration: 0.3 } }}
            >
              <div className="catalogo-image-wrapper">
                <img src={catalogo.imagen} alt={catalogo.nombre} />
                <div 
                  className="catalogo-overlay"
                  style={{ background: `linear-gradient(135deg, ${catalogo.color}dd, ${catalogo.color}99)` }}
                >
                  <motion.button
                    className="catalogo-btn"
                    onClick={() => handleViewPdf(catalogo.pdf)}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                      <polyline points="7 10 12 15 17 10"></polyline>
                      <line x1="12" y1="15" x2="12" y2="3"></line>
                    </svg>
                    Ver Catálogo
                  </motion.button>
                </div>
              </div>
              <div className="catalogo-content">
                <h3>{catalogo.nombre}</h3>
                <p>{catalogo.descripcion}</p>
                <motion.button
                  className="catalogo-download-btn"
                  onClick={() => handleDownloadPdf(catalogo.pdf)}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  style={{ backgroundColor: catalogo.color }}
                >
                  Descargar PDF
                </motion.button>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Catalogos;

